var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelchairAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3183 7.05973C15.4296 7.32762 16.1053 8.41349 15.8275 9.48508L14.3977 15H10.2495L9.08671 19.4851C8.80889 20.5567 7.68281 21.2082 6.57153 20.9403C5.46025 20.6724 4.7846 19.5865 5.06242 18.5149L6.61797 12.5149C6.8488 11.6246 7.67839 11 8.63012 11H11.1589L11.8032 8.51494C12.081 7.44335 13.2071 6.79183 14.3183 7.05973Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9264 4C16.9264 5.10457 15.9978 6 14.8523 6C13.7069 6 12.7783 5.10457 12.7783 4C12.7783 2.89543 13.7069 2 14.8523 2C15.9978 2 16.9264 2.89543 16.9264 4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 11.8186L15.4419 15.0962C15.724 15.4964 15.8889 15.9796 15.8889 16.5C15.8889 17.8807 14.7281 19 13.2963 19C12.0756 19 11.052 18.1865 10.7766 17.091L10.093 19.7276C9.99874 20.0913 9.83932 20.4227 9.62976 20.7132C10.6212 21.5163 11.9002 22 13.2963 22C16.4464 22 19 19.5376 19 16.5C19 14.5219 17.917 12.7877 16.2917 11.8186Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairAlt);
export default __webpack_public_path__ + "static/media/wheelchair-alt.cf0c344b2c3c122bc9a0e2fb0a141dad.svg";
export { ForwardRef as ReactComponent };